export const TRIPS_REPLATFORM_NOTICE_TITLE =
  "Business and personal trips are now separate.";

export const CORPORATE_PORTAL_TRIPS_URL =
  window.__mclean_env__?.CORPORATE_PORTAL_URL || "";

export const TRIPS_REPLATFORM_NOTICE_LINK_CLASS =
  "trips-replatform-notice-banner-link";

export const getTripsReplatformNoticeDescription = (
  corporatePortalUrl: string
) => {
  const corporatePortalLinkLabel = corporatePortalUrl
    .replace(/^https?:\/\//, "")
    .replace(/\/$/, "");

  return `To view trips booked with a business card, visit <a class="${TRIPS_REPLATFORM_NOTICE_LINK_CLASS}" href="${corporatePortalUrl}/trips" target="_blank">${corporatePortalLinkLabel}/trips</a> or select your card in the top navigation.`;
};
